(function ($) {
  Drupal.behaviors.anr_repromote_scrollVideo_mob_v1 = {
    attach: function (context) {
      $('#anr_repromote_mod2', context).once(function (idx, element) {
        const $thismodule = $(element);
        const $videoElem = $thismodule.find('#js-anr_repromote__scrollVid_bgVid');
        const triggerMod = '#anr_repromote_mod2';
        const thisModuleName = 'anr_repromote_mod2';
        const controller = new ScrollMagic.Controller();
        const moduleWillFade = $thismodule.data('scrollmagic') === 1;
        const urlHash = window.location.href.split('#')[1];
        let hasFaded = false;
        let offset, fadeThisModuleScene;
        let frameNumber = 0;
        const playbackConst = 100;
        const vid = $videoElem[0];
        let moduleOffsetVal, vidDuration;
        const moduleHeight = $videoElem.height();
        let yOffset = 0;
        let mppTarget,
          $thisparent = $thismodule.parent();

        if ($thisparent.parents('.node-elc-nodeblock').length) {
          mppTarget = $thismodule.parents().eq(3).prev('.mpp');
        } else {
          mppTarget = $thismodule.parent().prev('.mpp');
        }

        const targetDetach = mppTarget.find('.product-brief'),
          targetAttach = $thismodule.find('.js-el_boutique_qs_mob'),
          targetQSOpen_1 = mppTarget.find(
            'a.button__quickshop.product-brief__button-quickshop.js-quickshop-show'
          ),
          targetQSClose_1 = mppTarget.find(
            'a.product-brief__button-quickshop--close.js-quickshop-hide'
          );

        // If module is called in URL, scroll to module.
        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // Append Quickshop on Mobile
        function appendMobQuickshop() {
          if ($(window).width() <= 768) {
            mppTarget.addClass('mpp_qs_detached');
            mppTarget.detach().insertAfter($thisparent);
            targetQSOpen_1.addClass('shop_now_dark shop_now_centered');
            targetQSClose_1.addClass('shop_now_light shop_now_white shop_now_centered');
            // Need to wait for mpp to load.
            $(window).on('load', function () {
              targetDetach.detach().insertAfter(targetAttach);
              mppTarget.detach().appendTo($thismodule);
            });
          }
        }
        appendMobQuickshop();

        // Scrolling video functionality
        // Need to init playback for video to load on mobile.
        vid.play();
        vid.addEventListener('timeupdate', function () {
          if (vid.currentTime >= 0.002) {
            vid.pause();
          }
        });
        const readyState = setInterval(function () {
          if (vid.readyState > 0) {
            vidDuration = vid.duration;
            clearInterval(readyState);
          }
        }, 250);

        function onScrollVid() {
          $(window).on('scroll', function () {
            // Need to recalculate module offset to account for lazy elems.
            moduleOffsetVal = $videoElem.offset().top - 150;
            yOffset = window.pageYOffset - moduleOffsetVal + moduleHeight;
            frameNumber = yOffset / playbackConst;
            vid.currentTime = frameNumber;
            if (frameNumber >= vidDuration - 0.2) {
              vid.currentTime = vidDuration - 0.2;
            }
          });
        }
        $(window).one('scroll', _.throttle(onScrollVid, 250));

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });
            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
